









































































import moment from 'moment';
import Component from 'vue-class-component';
import CommonButton from '../button/CommonButton.vue';
import {Mixins, Prop} from 'vue-property-decorator';
import StringUtils from '../../utils/StringUtils';
import DateMixin from '@/utils/DateMixin';
import InputMixin from '@/components/input/InputMixin';
import TextInput from '@/components/input/TextInput.vue';

@Component({
    components: {
        TextInput,
        CommonButton
    },
    mixins: [DateMixin, InputMixin]
})
export default class DatePicker extends Mixins(DateMixin, InputMixin) {
    @Prop({default: 'bottom-end'}) private readonly placement: string;
    @Prop({default: 'YYYY-MM-DD'}) private readonly format: string;

    private readonly DATE_FORMAT: any = this.dateFormat;

    protected today: any = moment().tz(this.getTimezone()).format(this.DATE_FORMAT);

    protected bindedValue: any = '';

    get getPlacement() {
        return this.placement;
    }

    get dateFormat() {
        return this.format;
    }

    public mounted() {
        if (StringUtils.hasValue(this.inputValue)) {
            this.bindedValue = this.inputValue;
            this.bindCurrentYearAndMonth(this.inputValue, this.DATE_FORMAT);
        }
    }

    public getDayClass(date: string) {
        if (!StringUtils.hasValue(date)) {
            return;
        }

        const bindedDay = this.getDateByFormat(this.DATE_FORMAT, this.currentYear, this.currentMonth, date);
        
        return this.getCommonDayClass(date, this.today, bindedDay, this.bindedValue);
    }

    public bindCurrentYearAndMonth(date: any, format: any) {
        this.currentYear = moment(date, format).year();
        this.currentMonth = 1 + moment(date, format).month();
    }
                  
    public onDateClick(date: number) {
        if (date === undefined) {
            return;
        }
        const clickedDate = this.getDateByFormat(this.DATE_FORMAT, this.currentYear, this.currentMonth, date);
        this.bindDate(clickedDate);
        this.hide();
    }
            
    public onClickToday() {
        this.bindCurrentYearAndMonth(this.today, this.DATE_FORMAT);
        this.bindDate(this.today);
        this.hide();
    }
    
    public bindDate(date: any) {
        this.bindedValue = date;

        this.commitValue(this.bindedValue);
    }

    public show() {
        this.visible = true;
    }

    public hide() {
        this.visible = false;
    }

    public onShow($event: any) {
        this.$emit('show', $event);
    }

    /**
     * Datepicker의 Trigger reference 인 Input의 @clear 이벤트가 무시되기 때문에 @input 이벤트에 바인딩 하되
     * Clear일 때만 값이 emit 되도록 처리 함.
     *
     * @param data
     */
    public onChangeInput(data: any) {
        if (data === '') {
            this.commitValue(data);
        }
    }

    public commitValue(bindedValue: any) {
        this.$emit('input', bindedValue);
        if (this.changeDetectable) {
            this.$store.commit('commitValue', {
                itemId: this.getId,
                value: bindedValue,
                originValue: this.originValue
            });
        }
    }
}
